// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"260eaf36","667":"1b8a2a08"}[chunkId] + ".chunk.js";
};